import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute, NavigationStart } from '@angular/router';
import { filter } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';
import { AuthService } from '../../../services/auth/auth.service';

@Component({
  selector: 'app-confirm-user',
  templateUrl: './confirm-user.component.html',
  styleUrls: ['./confirm-user.component.css']
})
export class ConfirmUserComponent implements OnInit {
  /**
   * Acá se declaran las variables a utilizar en el resto de las funciones del componente, importante énfasis en las siguientes:
   *
   * code: Código del mensaje de respuesta a mostrar en la función.
   * titulo: Título a enviar; solo si se recibe con la respuesta del endpoint.
   * detalle: Detalle a enviar; solo si se recibe con la respuesta del endpoint.
   */
  confirmUserForm: FormGroup;
  visibleSpinner = false;
  error = false;
  correo = '';
  codigo = '';
  confirmacionForm = false;
  msgConfirm = true;
  msgExito = false;
  tipos: any = [];
  regExpUsuario: string = environment.regExpUsuario;
  regExpCorreo: string = environment.regExpCorreo;
  minLengthPass: number = environment.minLengthPass;
  nombreSistema: string = environment.nombreSistema;
  minLengthCodigo: number = environment.minLengthCodigo;
  // Variables para mensaje
  code: any;
  titulo: any;
  detalle: any;
  temp_mail_register: string;

  constructor(private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService) {

  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      if(params.ref && params.ref === "login"){
        this.temp_mail_register = '';
        sessionStorage.clear();
      }

      this.correo = params.correo;
      let okCorreo = false;
      if (this.correo !== undefined) {
        this.correo = this.correo.toLowerCase();

        const regex = new RegExp(this.regExpCorreo);
        okCorreo = regex.test(this.correo);
      }

      this.codigo = params.codigo;
      if (this.correo === undefined && this.codigo === undefined) {
        this.confirmacionForm = true;
      } else if (!okCorreo || this.codigo.length !== environment.longitudCodigoSeguridad) {
        this.confirmacionForm = true;
      } else {
        this.confirmacionForm = false;
      }

      if (okCorreo) {
        this.confirmacionUsuario(this.correo, this.codigo, false);
      } else {
        if (this.confirmacionForm) {
          setTimeout(() => {
            document.getElementById('correo').focus();
          }, 1000);

        }
      }

    });

    this.temp_mail_register = sessionStorage.getItem('temp_mail_register') ? sessionStorage.getItem('temp_mail_register') : '';
    this.confirmUserForm = this.formBuilder.group({
      correo: [{
        value: this.temp_mail_register ,
        disabled: (this.temp_mail_register  !== "") ? true : false
      }, [Validators.required, Validators.pattern(this.regExpCorreo)]],
      codigo: ['', [Validators.required, Validators.minLength(this.minLengthCodigo), Validators.maxLength(this.minLengthCodigo)]]
    });

  }

  confirmacionManual() {
    this.confirmacionUsuario(this.correo, this.codigo, true);
  }

  confirmacionUsuario(correo: string, codigo: string, confirmacionManual: boolean) {
    if (confirmacionManual) {
      this.visibleSpinner = true;
    }

    this.authService.confirmUser(correo, codigo)
      .subscribe((res: any) => {
        this.visibleSpinner = false;

        if (res.success) {
          if (res.status_code === 200) {
            this.msgConfirm = false;
            this.code = 'confirm_user.success.default';
            this.titulo = res.data.title;
            this.detalle = res.data.message;
            sessionStorage.setItem('temp_code_register', codigo);
            if(!sessionStorage.getItem('temp_mail_register')){
              sessionStorage.setItem('temp_mail_register', correo);
            }
            setTimeout(() => {
              // this.router.navigate(['auth/login']);
              this.router.navigate(['auth/change-pass']);
            }, 1500);
          }
        } else {
          this.msgConfirm = false;
          this.error = true;
          this.code = 'confirm_user.error.11';
          this.titulo = res.data.title;
          this.detalle = res.data.message;

          setTimeout(() => {
            this.router.navigate(['auth/solicitar-confirmacion']);
          }, 2000);
        }

      }, error => {
        this.visibleSpinner = false;
        this.error = true;
        this.code = 'confirm_user.error.12';
        this.titulo = 'Error en confirmación de usuario';
        this.detalle = error;
      });
  }

  confirmar() {
    const _send_mail = (this.temp_mail_register  !== "") ? this.temp_mail_register : this.confirmUserForm.value.correo;
    this.confirmacionUsuario(_send_mail, this.confirmUserForm.value.codigo, true);
  }

}
